module.exports = __webpack_public_path__ + "img/finland.a5471749.svg";